import { setAttachments, uploadAttachments, removeAttachment, removeAllAttachments } from "./UploadAttachmentsAction";

const dispatchSetAttachments = (dispatch: Function) => (attachments: any) => {
    dispatch(setAttachments(attachments));
};

const dispatchUploadAttachments = (dispatch: Function) => (attachmentsObject: any) => {
    dispatch(uploadAttachments(attachmentsObject));
};

const dispatchRemoveAttachment = (dispatch: Function) => (attachment: any) => {
    dispatch(removeAttachment(attachment));
};

const dispatchRemoveAllAttachments = (dispatch: Function) => () => {
    dispatch(removeAllAttachments());
};

const UploadAttachmentsDispatch = {
    dispatchSetAttachments,
    dispatchUploadAttachments,
    dispatchRemoveAttachment,
    dispatchRemoveAllAttachments
};


export default UploadAttachmentsDispatch